module.exports = __webpack_public_path__ + "static/media/skylder.a917b90c.mp3";